import { render } from "./editProjectForm.vue?vue&type=template&id=45dc6386&scoped=true"
import script from "./editProjectForm.vue?vue&type=script&lang=js"
export * from "./editProjectForm.vue?vue&type=script&lang=js"

import "./editProjectForm.vue?vue&type=style&index=0&id=45dc6386&scoped=true&lang=css"

import exportComponent from "/home/accesa/Documents/ACCESA/DANA_PROJECTS/DANA-LITE/dana-lite-registro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dc6386"]])

export default __exports__